import ApiService from "@/services/ApiService.js";

const state = {
    categories: []
}

const getters = {
    categories: state => state.categories
}

const mutations = {
    UPDATE_CATEGORY(state, payload) {
        state.categories = payload;
    }
}

const actions = {
    setCategory({ commit }) {
        return new Promise((resolve) => {
            ApiService.getCategory(0).then(res => {
            	console.log("category");
                let payload = [];
                if (res.masterProductCategoryResponse.length > 0) {
                    res.masterProductCategoryResponse.forEach((element) => {

                        if (element.parentId < 0) {
                            payload.push({
                                id: element.id,
                                title: element.name.trim(),
                                link: element.nameEng.trim().replace(/ /g, "-").toLowerCase(),
                                submenu: [],
                                img:element.img,
                                alt:element.alt,
                                txt:element.txt
                            });
                        } else {
                            if (payload.length > 0) {
                                payload.forEach((item) => {
                                    if (element.parentId === item.id && element.nameEng != null) {
                                        if (element.id === 241) {
                                            /*
                                            item.submenu.push({
                                                id: element.id,
                                                title: element.name.trim(),
                                                link: "driver"
                                            });
                                            */
                                        } else if (element.id === 251) {
                                            item.submenu.push({
                                                id: element.id,
                                                title: element.name.trim(),
                                                link: "coach-hire-custom"
                                            });
                                        } else if (element.id === 261) {
                                            item.submenu.push({
                                                id: element.id,
                                                title: element.name.trim(),
                                                link: "coach-hire-suggest"
                                            });
                                        } else {
                                            item.submenu.push({
                                                id: element.id,
                                                title: element.name.trim(),
                                                link:element.nameEng.trim().replace(/ /g, "-").toLowerCase(),
                                                img:element.img,
                                                alt:element.alt,
                                                txt:element.txt
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
                commit('UPDATE_CATEGORY', payload);
                resolve();
            }).catch(error => {
                commit('UPDATE_CATEGORY', []);
                resolve();
                throw new Error(`API ${error}`);
            });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}